var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"nav"}},[(_vm.show)?_c('div',{attrs:{"id":"nav"}},[_c('div',{staticClass:"nav__wrapper"},[_vm._l((_vm.projects),function(project,key){return _c('nav-item',{key:key,attrs:{"data":project,"active":project.slug == _vm.active.slug ? true : false,"index":++key}})}),_vm._v(" "),_c('lines')],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d841d9c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
// module id = null
// module chunks = 